import { lazy ,useEffect , useContext,Suspense } from "react";
import { Route,Routes,useNavigate } from "react-router-dom";
import {GlobalStateContext} from "@utils/GlobalContext"
import { setStoredRedirectUrl } from "@utils/utils"
const Consulenti = lazy(()=>import('@routes/consulenti/Consulenti'))
const Gateway = lazy(()=>import('@routes/gateway/Gateway'))
const Profilo = lazy(()=> import('@routes/profilo/Profilo'));
const TrovaNegozi = lazy(()=> import("@routes/trova-negozi/TrovaNegozi"));
const Pagamenti = lazy(()=> import("@routes/pagamenti/Pagamenti"));
const Home = lazy(()=> import("@routes/home/Home"));
const Dilazioni = lazy(()=> import("@routes/dilazioni/Dilazioni"));
const Abbonamenti = lazy(()=> import("@routes/abbonamenti/Abbonamenti"));
const Sviluppatori = lazy(()=> import("@routes/sviluppatori/Sviluppatori"));
const Clienti = lazy(()=> import("@routes/clienti/Clienti"));
const Utenze = lazy(()=> import("@routes/utenze/Utenze"));
const Reports = lazy(()=> import("@routes/reports/Reports"));
const Documenti = lazy(()=> import("@routes/documenti/Documenti"));
const Fatture = lazy(()=> import("@routes/fatture/Fatture"));
const Esercente = lazy(()=> import("@routes/esercente/Esercente"));
const Cliente = lazy(()=> import("@routes/cliente/Cliente"));
const RegistrazioneEsercente = lazy(()=> import("@routes/registrazione/esercente/RegistrazioneEsercente"));
const RegistrazioneCliente = lazy(()=> import("@routes/registrazione/cliente/RegistrazioneCliente"));
const AbbonamentiCliente = lazy(()=> import("@routes/cliente/Abbonamenti"));
const DilazioniCliente = lazy(()=> import("@routes/cliente/Dilazioni"));
const PagamentiCliente = lazy(()=> import("@routes/cliente/Pagamenti"));
const AbbonamentiEsercente = lazy(()=> import("@routes/esercente/Abbonamenti"));
const DilazioniEsercente = lazy(()=> import("@routes/esercente/Dilazioni"));
const PagamentiEsercente = lazy(()=> import("@routes/esercente/Pagamenti"));
const Piattaforma = lazy(()=> import("@routes/piattaforma/Piattaforma"))
const Promozioni = lazy(()=> import("@routes/promozioni/Promozioni"))
// const NotificationMessage = lazy(()=> import("@components/notification-message/NotificationMessage"));
const Inattivo = lazy(()=> import("@routes/inattivo/Inattivo"));
const Esercenti = lazy(()=> import("@routes/esercenti/Esercenti"));
const RichiediAssistenza = lazy(()=> import("@routes/richiedi-assistenza/RichiediAssistenza"));


function Main(){
  const {profile,setRedirectUrl} = useContext(GlobalStateContext)
    const navigate = useNavigate()

    useEffect(() => {

      let title =window.location.pathname.split('/')[1]
      
      title=title.charAt(0).toUpperCase()+title.slice(1)
      if (!title) title = 'Home'
      document.title = 'JataPay - '+title;
  }, [location.pathname]);

    useEffect(()=>{
      if(profile &&Object.keys(profile).length>0&& (profile['regitering']||!profile['_id'])){ //cambiarlo poi togliendo il not
        const currentUrl = window.location.pathname + window.location.search
        if (!currentUrl.startsWith('/registrazione')) {
          setStoredRedirectUrl(currentUrl)
        }
        const stored = localStorage.getItem('redirectUrl')
        if (stored) setRedirectUrl(stored)
        if (!currentUrl.startsWith('/registrazione')) {
          navigate('/registrazione?state='+ new URLSearchParams(window.location.search).get('state'))
        }
      }
    },[profile])
    return <main>
    <Routes>
    {profile&&Object.keys(profile).length>0&&profile['stato']!=='inattivo'?<>
    {!profile['regitering']&&profile['_id']?<>

      <Route path='/profilo' element={<Suspense fallback={<></>}><Profilo/></Suspense>}/>
      <Route path='/pagamenti' element={<Suspense fallback={<></>}>
      <Pagamenti/>
      </Suspense>
      }/>
      {profile.role === 'admin'&&<>
        <Route path="/consulenti" element={<Suspense fallback={<></>}><Consulenti/></Suspense>}/>
        <Route path="/gestione" element={<Suspense fallback={<></>}><Piattaforma/></Suspense>}/>
        <Route path="/promozioni" element={<Suspense fallback={<></>}><Promozioni/></Suspense>}/>
        <Route path="/esercenti" element={<Suspense fallback={<></>}><Esercenti/></Suspense>}/>
        <Route path="/fatture" element={<Suspense fallback={<></>}><Fatture/></Suspense>}/>
        <Route path="/reports/:ObjectId" element={<Suspense fallback={<></>}><Reports/></Suspense>}/>

      </>}
      

      <Route path="/dilazioni" element={<Suspense fallback={<></>}><Dilazioni/></Suspense>}/>
      <Route path="/abbonamenti" element={<Suspense fallback={<></>}><Abbonamenti/></Suspense>}/>
      <Route path="/sviluppatori" element={<Suspense fallback={<></>}><Sviluppatori/></Suspense>}/>
      <Route path='/' element={<Suspense fallback={<></>}><Home/></Suspense>}/>
      <Route path='/home' element={<Suspense fallback={<></>}><Home/></Suspense>}/>
      <Route path='/gateway/:id' element={<Suspense fallback={<></>}><Gateway/></Suspense>}/>
      <Route path='/home/:role' element={<Suspense fallback={<></>}><Home/></Suspense>}/>
      <Route path="/ricerca_esercenti" element={<Suspense fallback={<></>}><TrovaNegozi/></Suspense>}/>
      <Route path="/clienti" element={<Suspense fallback={<></>}><Clienti/></Suspense>}/>
      <Route path="/utenze" element={<Suspense fallback={<></>}><Utenze/></Suspense>}/>
      <Route path="/reports" element={<Suspense fallback={<></>}><Reports/></Suspense>}/>
      <Route path="/documenti" element={<Suspense fallback={<></>}><Documenti/></Suspense>}/>
      <Route path="/cliente/:ObjectID" element={<Suspense fallback={<></>}><Cliente/></Suspense>}/>
      <Route path="/cliente/:ObjectID/abbonamenti" element={<Suspense fallback={<></>}><AbbonamentiCliente/></Suspense>}/>
      <Route path="/cliente/:ObjectID/dilazioni" element={<Suspense fallback={<></>}><DilazioniCliente/></Suspense>}/>
      <Route path="/cliente/:ObjectID/pagamenti" element={<Suspense fallback={<></>}><PagamentiCliente/></Suspense>}/>
      <Route path="/esercente/:ObjectID/abbonamenti" element={<Suspense fallback={<></>}><AbbonamentiEsercente/></Suspense>}/>
      <Route path="/esercente/:ObjectID/dilazioni" element={<Suspense fallback={<></>}><DilazioniEsercente/></Suspense>}/>
      <Route path="/esercente/:ObjectID/pagamenti" element={<Suspense fallback={<></>}><PagamentiEsercente/></Suspense>}/>
      <Route  path="/esercente/:ObjectID" element={<Suspense fallback={<></>}><Esercente/></Suspense>}/>
      <Route path="/assistenza" element={<Suspense fallback={<></>}><RichiediAssistenza/></Suspense>}/>
      <Route path={'*'} element={<Suspense fallback={<></>}><Home/></Suspense>}/> {/* 404 */}
    </>:<>
    <Route path="*" element={profile&&profile['role']==='esercente'?<Suspense fallback={<></>}><RegistrazioneEsercente/></Suspense>:<Suspense fallback={<></>}><RegistrazioneCliente/></Suspense>}/>
    <Route path="/registrazione" element={profile&&profile['role']==='esercente'?<Suspense fallback={<></>}><RegistrazioneEsercente/></Suspense>:<Suspense fallback={<></>}><RegistrazioneCliente/></Suspense>}/>
    </>
    }
    </>:profile&&Object.keys(profile).length>0&&profile['stato']==='inattivo'?<Route path="*" element={<Suspense fallback={<></>}><Inattivo/></Suspense>}/>:<Route path="*" element={<Suspense fallback={<></>}><></></Suspense>}/>
}
  </Routes>

    </main>

}export default Main

